<template>
  <div class="drawer-detail">
    <div class="field-type" style="padding-bottom:0px;">
      <p class="label">人才流入流出<span :class="[hasSankey?'link-text':'gray-text','ml10']" @click="showSankey"><i class="el-icon-view"></i>查看图表</span></p>
    </div>

    <table v-if="inRank.length||outRank.length" class="pic-analyse-table">
      <tr>
        <td>流入公司</td>
        <td style="width:40px">人数</td>
        <td>流出公司</td>
        <td style="width:40px">人数</td>
      </tr>
      <tr v-for="i in 5" :key="`tableTr${i}`">
        <td>{{inRank[i-1]&&inRank[i-1].公司}}</td>
        <td class="link-text" @click="showInOutDetail(inRank[i-1]&&inRank[i-1].data)">{{inRank[i-1]&&inRank[i-1].人数}}</td>
        <td>{{outRank[i-1]&&outRank[i-1].公司}}</td>
        <td class="link-text" @click="showInOutDetail(outRank[i-1]&&outRank[i-1].data)">{{outRank[i-1]&&outRank[i-1].人数}}</td>
      </tr>
    </table>
    <div v-else class="gray-text value company-pre" style="background: #2478b526;">
      <p>暂无数据</p>
    </div>
    <div class="field-type">
      <p class="label">人才画像分析<span class="link-text ml10" @click="showTable"><i class="el-icon-view"></i>查看图表</span></p>
    </div>
    <Sankey ref="Sankey" :flow-graphy="flowGraphy" @changeDate="loadData"></Sankey>
    <AnalyseTable ref="AnalyseTable"></AnalyseTable>
    <InoutDetail ref="InoutDetail" style="left: calc(50vw - 200px);top: 230px;"></InoutDetail>
  </div>
</template>
<script>
import Sankey from './Sankey'
import AnalyseTable from './AnalyseTable'
import InoutDetail from '../../../../../company/src/dialog/inoutDetailDialog'

const dateFormat = require('dateformat')

export default {
  components:{ Sankey, InoutDetail, AnalyseTable },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      flowGraphy:{},
      inRank:[],
      outRank:[],
      companyNameMap:{},
      hasSankey:false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    showSankey(){
      if(this.hasSankey){
        this.$refs.Sankey.open(this.company)
      }
    },
    showTable(){
      this.$refs.AnalyseTable.open(this.company)
    },
    showInOutDetail(radishes) {
      if (!Array.isArray(radishes) || radishes.length === 0) return
      this.$refs.InoutDetail.open(radishes,this.company.行业 === '私募股权（PEVC）')
    },
    async getCompanies(arr){
      const res = await app.service('company').getCompanyListByName(arr)

      const companies = res.status==='success'?res.data: []
      companies.forEach(v=>{
        this.companyNameMap[v.公司名称] = v.简称
      })
    },
    async loadData(date){
      if(this.sankeyLoading) return this.$message.error('获取数据中，请稍后重试')
      this.sankeyLoading = true
      const thisYear = new Date().getFullYear()
      const thisMonth = new Date().getMonth() + 1
      const transferDate = date || [new Date(`${thisYear - 1}-${thisMonth}`), new Date(`${thisYear}-${thisMonth}`)]
      const query = {
        时间段: { $gte: dateFormat(transferDate[0], 'yyyy-mm-dd'), $lte: dateFormat(transferDate[1], 'yyyy-mm-dd') },
        公司: this.company.简称,
      }
      let res
      if (this.company.行业 === '私募股权（PEVC）') {
        delete query.时间段
        res = await app.service('statistics').getPevcFlowGraphy(query)
      } else {
        res = await app.service('statistics').getFlowGraphy(query)
      }
      if (res.status === 'success') {
        const names = res.data.nodes.map(v=>v.name)
        if(names.length!==0) await this.getCompanies(names)
        this.flowGraphy = res.data
        const progressData = await this.$refs.Sankey && this.$refs.Sankey.processData(res.data)
        if(!progressData) return
        this.hasSankey = progressData.data&&progressData.data.length&&progressData.links&&progressData.links.length
        this.$refs.Sankey.loadSankey(res.data)
        this.loadTable(res.data)
      } else this.$message.error(res.msg)
      this.sankeyLoading = false
    },
    loadTable({ nodes, linkList, transfer }) {
      const companyName = this.company.公司名称
      const { companyNameMap } = this

      const countIn = {}
      const countOut = {}
      transfer.forEach((radish) => {
        if (radish.来源公司 === this.company.公司名称 || radish.来源公司 === this.company.简称) {
          if (!countOut[radish.目标公司]) countOut[radish.目标公司] = []
          countOut[radish.目标公司].push(radish)
        } else if (radish.目标公司 === this.company.公司名称 || radish.目标公司 === this.company.简称) {
          if (!countIn[radish.来源公司]) countIn[radish.来源公司] = []
          countIn[radish.来源公司].push(radish)
        }
      })

      const inRank = Object.keys(countIn)
        .map((com) => ({ 公司: companyNameMap[com]||com, data: countIn[com], 人数: countIn[com].length }))
        .sort((a, b) => b.人数 - a.人数)
        .splice(0,5)
      const outRank = Object.keys(countOut)
        .map((com) => ({ 公司: companyNameMap[com]||com, data: countOut[com], 人数: countOut[com].length }))
        .sort((a, b) => b.人数 - a.人数)
        .splice(0,5)
      this.inRank = inRank
      this.outRank = outRank
    },
  },
}
</script>
<style scoped src="../../../../../company/statistics/css/NewFullCompany.css"></style>
<style src="../../constant/css/detail.css" scoped></style>
<style scoped>
.company-tag {
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
.pic-analyse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #5aa2ea;
  padding: 10px;
  color: #fff;
}

.pic-analyse-table {
  width: 100%;
}
.pic-analyse-table td {
  width: 33%;
  padding: 5px 10px;
}
.pic-analyse-table .analyse-td-label {
  text-align: left;
  margin-bottom: 10px;
}
.pic-analyse-table .analyse-td-content {
  /* width: 16%; */
}
.alert-text{
  color:#ff3300;
}
</style>
